export default __webpack_public_path__ + "static/media/LAS0830.34I-38293_-24625_0.aef19568.jpg";